<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card"> 

        
        
        <div class="p-mb-4 p-d-flex p-jc-between p-toolbar">
          <div>
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="globalFilter"
                placeholder="Global Search"
                style="margin-right: 0.5em"
                @input="updateSearch"
              />
            </span>
          </div>
        </div>
        
        <HistoryTable
          :data="userHistory"
          :name="'User History'"
          :loading="loading"
          :globalFilter="globalFilter"
          :user="user"
        />

      </div>
    </div>
  </div>
</template>

<script>
import UserService from "@/service/UserService";

import HistoryTable from './LoginHistoryTable'

export default {
  components: {
    HistoryTable
  },
  props: ["user"],
  data: () => ({
    userService: new UserService(),
    globalFilter: '',
    userHistory: [],
    requesting: false
  }),
  computed: {
    loading() {
      if (this.userHistory && this.userHistory[0]) {
        return false
      } else {
        if (this.requesting) {
          return true
        } else {
          return false
        }
      }
    },
  },
  created() {
    if (this.$route.query.search !== '') {
      this.updateSearch('')
    }

    this.setupComponent()
  },
  methods: {
    setupComponent() {
      
      if (this.$route.params.userid) {
        this.requesting = true
        this.userService
          .getUserLoginHistory(this.$route.params.userid)
          .then(data => {
            this.requesting = false
            this.userHistory = data
          })
          .catch(err => {
            this.requesting = false
            
            // this.$toast.add({
            //   severity: "error",
            //   summary: "Error",
            //   detail: "Error while getting user history.",
            //   life: 5000,
            // })
            this.$store.dispatch('addErrorMessage', {
              severity: 'error',
              content: 'Some data was not loaded from "loginHistoryByUser/{userId}"'
            })
          })
      }
    },
    updateSearch(e) {
      this.$router.push({ query: { search: e } });
    }
  }
}
</script>

<style>

</style>